let intialState = {
    scheduleList: [],
    facultyList: [],
    isListLoading: true,
    isStudentScheduleLoading: true,
    schedulePagination: {}
}

export default function scheduleReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case "Add_Class":
            stateCopy.scheduleList = [...stateCopy.scheduleList, action.payload];
            return stateCopy;
        case "Get_All_Classes_List":
            stateCopy.scheduleList = action.payload.data;
            stateCopy.isListLoading = false;
            stateCopy.schedulePagination = action.payload.pagination;
            return stateCopy;
        case "Get_Faculties_List":
            stateCopy.facultyList = action.payload.map(el => [{ value: el._id, label: el.firstName + ' ' + el.lastName}][0]);
            return stateCopy;
        case "Get_Batches_List":
            stateCopy.batchesList = action.payload.map(el => [{ value: el._id, label: el.title}][0]);
            return stateCopy;
        case "Get_Subjects_List":
            stateCopy.subjectList = action.payload.map(el => [{ value: el._id, label: el.title}][0]);
            return stateCopy;
        case "Select_All_Classes":
            if (action.payload) {
                stateCopy.scheduleList.forEach(el => {
                    el.isChecked = true
                })
            }
            else {
                stateCopy.scheduleList.forEach(el => {
                    el.isChecked = false
                })
            }
            return stateCopy;
        case "Select_One_Class":
            if (action.payload.checked) {
                stateCopy.scheduleList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = true
                    }
                })
            }
            else {
                stateCopy.scheduleList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = false
                    }
                })
            }
            return stateCopy;
        case "Get_Class_By_Id":
            stateCopy.classById = action.payload;
            return stateCopy;
        case "Activate_Class":
            const classIds = action.payload.class_ids || [];
            const newStatus = action.payload.active;
            stateCopy.scheduleList = stateCopy.scheduleList.map(item => 
                classIds.includes(item._id) 
                    ? { ...item, active: newStatus } 
                    : item
            );
            return stateCopy;
        case "Get_Student_Schedule_List":
            stateCopy.studentScheduleList = action.payload.data;
            stateCopy.isStudentScheduleLoading = false;
            stateCopy.studentSchedulePagination = action.payload.pagination;
            return stateCopy;
        case "Get_Student_Present_Data":
            stateCopy.studentPresentData = action.payload.map(item => {
                return {
                    batch: item.batch?.title || '',
                    firstName: item.firstName || '',
                    lastName: item.lastName || '',
                    email: item.proxy_email || item.email || '',
                    student_id: item.student_id || ''
                }
            });
            stateCopy.isStudentPresentDataLoading = false;
            return stateCopy;
        case "Get_Student_Subjects_List":
            stateCopy.studentSubjectList = action.payload.map(el => [{ value: el._id, label: el.title}][0]);
            return stateCopy;
        case "Get_Student_Faculties_List":
            stateCopy.studentFacultyList = action.payload.map(el => [{ value: el._id, label: el.firstName + ' ' + el.lastName}][0]);
            return stateCopy;
        default:
            return stateCopy;
    }
}